import React from 'react'

export default function ChoiceInput() {
  return null
}
